import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { formatDate } from "@/lib/content";

export default function NewsFlash() {
  const latest = [...newsList]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);

  return (
    <div className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="flex items-center gap-2 text-base md:text-lg font-bold text-foreground-950">
          <span className="w-7 h-7 rounded-md bg-accent-500 text-background-50 flex items-center justify-center shrink-0">
            <i className="ri-flashlight-fill text-sm" />
          </span>
          最新娱乐快报
        </h3>
        <span className="text-xs text-foreground-400">实时更新</span>
      </div>
      <ul className="divide-y divide-background-200/70">
        {latest.map((item) => (
          <li key={item.id}>
            <Link
              to={`/news/${item.id}`}
              className="group flex items-start gap-3 py-3 cursor-pointer"
            >
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary-400 shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-sm text-foreground-800 font-medium leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
                <p className="mt-1 text-xs text-foreground-400">
                  <span className="text-accent-600">{item.category}</span>
                  <span className="mx-2">·</span>
                  {formatDate(item.date)}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}